import React from 'react';

import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import styles from './SkipContent.module.scss';

const SkipContent = () => {
    const { t } = useTranslation();
    return (
        <a href="#main-content" className={styles['Root']}>
            {t('SkipContent.text')}
        </a>
    );
};

SkipContent.propTypes = {};

export default SkipContent;
